import React, { createContext, useContext, useState, useEffect } from "react";
import {
  getCurrentUser,
  login as loginAPI,
  logout as logoutAPI,
} from "../services/auth";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("jwtToken"));
  const [loading, setLoading] = useState(true);

  // Check if user is authenticated on app load
  useEffect(() => {
    const checkAuth = async () => {
      const savedToken = localStorage.getItem("jwtToken");
      if (savedToken) {
        try {
          const response = await getCurrentUser();
          // Support both old and new API structure
          const userData =
            response.user || (response.data && response.data.user) || response;
          setUser(userData);
          setToken(savedToken);
        } catch (error) {
          localStorage.removeItem("jwtToken");
          setToken(null);
          setUser(null);
        }
      } else {
        setUser(null);
        setToken(null);
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  const login = async (email, password) => {
    try {
      const response = await loginAPI(email, password);
      const { token: newToken, user: userData } = response;
      if (newToken) {
        localStorage.setItem("jwtToken", newToken);
        setToken(newToken);
      }
      setUser(userData);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.message || "Login failed",
      };
    }
  };

  const logout = async () => {
    try {
      await logoutAPI();
    } catch (e) {}
    localStorage.removeItem("jwtToken");
    setToken(null);
    setUser(null);
  };

  const isAuthenticated = () => {
    return !!token && !!user;
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    isAuthenticated,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
